import { PokemonSeries } from "@/const/pokemon"
import { getEntries } from "@/utils/object"

export type Content = { 
  headline: string;
  items: Array<{ text: string; link: string; isExternal?: boolean; }> 
}

export const guides: Content = {
  headline: 'ご利用ガイド',
  items: [
    {
      text: '会社情報',
      link: '/guides#about'
    },
    {
      text: '利用条件',
      link: '/guides#terms'
    },
    {
      text: '送料・配送方法',
      link: '/guides#delivery'
    },
    {
      text: '支払方法',
      link: '/guides#payment'
    },
    {
      text: '発送・到着日',
      link: '/guides#date'
    },
    {
      text: '注文キャンセル',
      link: '/guides#cancel'
    },
    {
      text: '返品・交換',
      link: '/guides#returns'
    },
    {
      text: 'カードの状態',
      link: '/pokemon/conditions'
    },
    {
      text: '会員引継ぎ',
      link: '/guides#migration'
    },
    {
      text: 'お問合せ',
      link: '/help'
    },
  ]
}

/**
 * シリーズは、基本は id の降順で並べるが
 * LEGEND、Classicなど、一番古いシリーズだが、後から取り扱うようになったシリーズを
 * 明示的に後ろに差し込むための、sort順を返す関数
 */
const getPokemonSeriesSortOrderByName = (id: number, name: string): number => {
  switch(name) {
    case 'MEGAシリーズ':
      return 10
    case 'LEGENDシリーズ':
      return -10
    case 'DPtシリーズ':
      return -20
    case 'DPシリーズ':
      return -30
    case 'PCGシリーズ':
      return -40
    case 'ADVシリーズ':
      return -50
    case 'eシリーズ':
      return -60
    case '★neoシリーズ':
      return -70
    case 'PMCGシリーズ':
      return -80
    case 'Classicシリーズ':
      return -90
    default:
      return id
  }
}

export const shopSeries = {
  headline: '販売中のポケカシリーズ',
  items: getEntries(PokemonSeries).sort(
    ([aSeriesId, aSeriesName], [bSeriesId, bSeriesName]) => {
      const aSort = getPokemonSeriesSortOrderByName(aSeriesId, aSeriesName)
      const bSort = getPokemonSeriesSortOrderByName(bSeriesId, bSeriesName)

      return bSort - aSort
    }
  ).map(
    ([seriesId, seriesName]) => ({
      text: seriesName,
      link: `/pokemon/series/${seriesId}`
    })
  )
}

export const cardGenreList: Content = {
  headline: 'カード種別一覧',
  items: [
    {
      text: '[販売]ポケモンカードゲーム',
      link: '/pokemon',
    },
    {
      text: '[買取]ポケモンカードゲーム',
      link: 'https://www.ka-nabell.com/?act=buy_top&genre=10',
      isExternal: true,
    },
    {
      text: '[販売]デュエル・マスターズ',
      link: 'https://www.ka-nabell.com/?genre=7',
      isExternal: true,
    },
    {
      text: '[買取]デュエル・マスターズ',
      link: 'https://www.ka-nabell.com/?act=buy_top&genre=7',
      isExternal: true,
    },
    {
      text: '[販売]遊戯王OCG デュエルモンスターズ',
      link: 'https://www.ka-nabell.com/?genre=1',
      isExternal: true,
    },
    {
      text: '[買取]遊戯王OCG デュエルモンスターズ',
      link: 'https://www.ka-nabell.com/?act=buy_top&genre=1',
      isExternal: true,
    },
    {
      text: '[販売]ラッシュデュエル',
      link: 'https://www.ka-nabell.com/?act=sell_search&category=78042&lang=&supply=&type=4&genre=1',
      isExternal: true,
    },
    {
      text: '[買取]ラッシュデュエル',
      link: 'https://www.ka-nabell.com/?act=buy_search&category=78042&lang=&type=4&genre=1',
      isExternal: true,
    },
    {
      text: '[販売]マジック：ザ・ギャザリング',
      link: 'https://www.ka-nabell.com/?genre=6',
      isExternal: true,
    },
    {
      text: '[買取]マジック：ザ・ギャザリング',
      link: 'https://www.ka-nabell.com/?act=buy_top&genre=6',
      isExternal: true,
    },
  ]
}
